import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import {
	akEditorSmallZIndex,
	relativeFontSizeToBase16,
	getParticipantColor,
} from '@atlaskit/editor-shared-styles';

// CSS for the small violator/badge in the bottom right of each avatar
const badgeStyles = css({
	display: 'block',
	position: 'absolute',
	right: '1px',
	bottom: '1px',
	width: '13px',
	height: '13px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: akEditorSmallZIndex,
	borderRadius: '3px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: relativeFontSizeToBase16(9),
	paddingTop: token('space.025'),
	textAlign: 'center',

	boxShadow: `0 0 1px ${token('color.border.inverse')}`,
	boxSizing: 'border-box',
});

const getAvatarBadgeColor = (id: string): { backgroundColor: string; textColor: string } => {
	const participantColor = getParticipantColor(id);

	return {
		backgroundColor: participantColor.color.backgroundColor,
		textColor: participantColor.color.textColor,
	};
};

export const AvatarBadge = (props: { name: string; sessionId: string; presenceId?: string }) => {
	const { backgroundColor, textColor } = getAvatarBadgeColor(props.presenceId ?? props.sessionId);
	const firstInitialOfName = props.name.substring(0, 1).toUpperCase();
	return (
		<div
			css={badgeStyles}
			data-testid="editor-presence-avatar-item"
			style={{ backgroundColor, color: textColor }}
		>
			{firstInitialOfName}
		</div>
	);
};
